module.exports = __webpack_public_path__ + "img/lib_region_flag_md.a0f594e4.png";